var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedActive = function SvgLinkedActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#linkedActive_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#FF9500",
    rx: 10.435
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 9,
    fill: "#1F90EA"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#65C366",
    d: "M0 0h16v48H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E040FB",
    d: "M32 0h16v48H32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2DA0FC",
    fillRule: "evenodd",
    d: "M24 36c6.627 0 12-5.373 12-12s-5.373-12-12-12-12 5.373-12 12 5.373 12 12 12m-7.316-13.039c-.584 0-1.048.45-1.048 1.018a1.04 1.04 0 0 0 1.048 1.045h9.995v1.771c0 .913.889 1.243 1.619.688L32 24.706a.857.857 0 0 0 0-1.4l-3.702-2.79c-.704-.53-1.62-.252-1.62.687v1.758z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.635 23.98c0-.57.464-1.019 1.048-1.019h9.995v-1.758c0-.939.915-1.216 1.619-.687l3.702 2.79a.857.857 0 0 1 0 1.4l-3.702 2.777c-.73.555-1.62.225-1.62-.688v-1.771h-9.994a1.04 1.04 0 0 1-1.048-1.045"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "linkedActive_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#fff",
    rx: 10.435
  })))));
};
export default SvgLinkedActive;